import React from "react";
import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";
import { PageHeader, Panel } from "../components/terminal/Page";

// /news — honest state: no provider connected, no invented headlines.
export default function NewsPage() {
  return (
    <div className="space-y-3" data-testid="page-news">
      <PageHeader title="Market News" subtitle="Real-time market news for your instruments." />
      <Panel testid="news-empty">
        <div className="py-12 flex flex-col items-center text-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-secondary flex items-center justify-center"><Newspaper className="h-6 w-6 text-muted-foreground" /></div>
          <div className="font-semibold">No external news provider connected.</div>
          <p className="text-sm text-muted-foreground max-w-md">Fela R.I.O never shows fabricated headlines. Connect a supported news source to enable real-time market news for the instruments you trade.</p>
          <Link to="/settings#integrations" data-testid="news-connect" className="h-9 px-4 rounded-lg bg-primary text-primary-foreground text-sm font-semibold flex items-center">Connect a news source</Link>
        </div>
      </Panel>
    </div>
  );
}
